@if (hasHeader) {
  <div class="page-header-container" (window:resize)="onResize()">
    <div id="page-header" class="wrapper">
      <div class="inline-element header-left">
        <button type='button' aria-label="Toggle sidenav" mat-icon-button (click)="openSidenav()" class="accent-color">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <img class="logo-toolbar" alt="GMA" src="assets/img/gma_logo.png" />
        @if (primaryTitle) {
          <h1 #primaryTitleEl class="primary-color primary-tittle"
          [matTooltip]="primaryTitle" [matTooltipDisabled]="!isTitleOverflowing">{{primaryTitle}}</h1>
        }
      </div>
      <div class="header-right">
        <ng-content select="[header]"></ng-content>
      </div>
    </div>
  </div>
}

<div id="page-content" [ngStyle]="{'margin-top': contentMarginTop, 'margin-bottom': contentMarginBottom}">
  <ng-content></ng-content>
</div>

@if (hasFootnote) {
  <div class="page-footnote-container">
    <div id="page-footnote">
      <ng-content select="[footnote]"></ng-content>
    </div>
  </div>
}
